module.exports = __webpack_public_path__ + "img/clipboard-check.b47136f5.svg";